// firebaseConfig.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// 🔥 CRITICAL FIX: enableIndexedDbPersistence 제거 - Admin에서는 오프라인 지속성 불필요 및 TDZ 오류 방지
import { getFirestore, collection, addDoc, getDocs, query, where, serverTimestamp, updateDoc, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// 🔥 Admin에서는 FCM이 필요 없으므로 import 제거 (TDZ 오류 방지)
// import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

// ========================
// Firebase Environment Variables Configuration (Unified based on kairos-platform-1ffde)
// ========================
/** authDomain: 미얀마 등에서 VPN 없이 쓰려면 Hosting 커스텀 도메인(예: admin.kairos-global-k.com) 연결 후 동일 값으로 빌드 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCi5g-FcdsXmcGGuSad_mloYHF-UDPkZhQ',
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'kairos-platform-1ffde.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'kairos-platform-1ffde',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'kairos-platform-1ffde.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '187210145908',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:187210145908:web:bf07da2ef5b113940a7121',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-307EWR560G',
};

// ========================
// Firebase App Initialization (Admin Only)
// ========================
// 🔥 CRITICAL FIX: TDZ 오류 완전 해결 - app을 먼저 const로 초기화한 후 export
// 모든 초기화를 먼저 완료한 후 마지막에 한 번에 export하여 TDZ 문제 완전 해결
const app = (() => {
  try {
    // Try to get existing Admin app instance
    return getApp('admin-kairos');
  } catch (error) {
    // Create new app instance if not exists
    return initializeApp(firebaseConfig, 'admin-kairos');
  }
})();

// 🔥 CRITICAL FIX: app이 확실히 초기화되었는지 확인
if (!app) {
  throw new Error('Firebase app initialization failed');
}

// ========================
// Auth, Firestore, Storage 초기화 (export 전에 모두 초기화)
// ========================
// 🔥 CRITICAL FIX: 모든 초기화를 먼저 완료한 후 마지막에 export
const auth = getAuth(app);

// ========================
// Admin-specific Auth State Management
// ========================
// Admin 앱에서는 항상 admin 세션만 유지
const ADMIN_SESSION_KEY = 'kairos-admin-session';

// Admin 로그인 시 세션 마커 설정
const setAdminSession = () => {
  localStorage.setItem(ADMIN_SESSION_KEY, 'active');
  localStorage.setItem('kairos-app-type', 'admin');
};

// Admin 로그아웃 시 세션 마커 제거
const clearAdminSession = () => {
  localStorage.removeItem(ADMIN_SESSION_KEY);
  localStorage.removeItem('kairos-app-type');
};

// Admin 세션 확인
const isAdminSession = () => {
  return localStorage.getItem(ADMIN_SESSION_KEY) === 'active';
};

// Firestore 초기화
// 🔥 CRITICAL FIX: enableIndexedDbPersistence 완전히 제거
// Admin 웹 앱에서는 오프라인 지속성이 필요 없으며, 모듈 초기화 시점에 실행되면 TDZ 오류 발생
// 관리자는 항상 온라인 상태에서 작업하므로 오프라인 지속성 불필요
// 🔥 CRITICAL FIX: 모든 초기화를 먼저 완료한 후 마지막에 export
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Unified appId for global use (from environment or fallback)
const appId = import.meta.env.VITE_APP_ID || "kairos-platform-1ffde";

// ========================
// FCM (Firebase Cloud Messaging) Initialization
// ========================
// Admin 웹 앱에서는 FCM이 필요 없으므로 완전히 제거 (TDZ 오류 방지)
// 관리자는 브라우저에서 직접 작업하므로 푸시 알림이 불필요함
// 🔥 messaging export 제거 - Admin에서는 FCM 사용 안 함

// ========================
// FCM Token Request + Firestore Storage + Auto Refresh
// ========================
// Admin 웹 앱에서는 FCM 토큰이 필요 없음
// 관리자는 브라우저에서 직접 작업하므로 푸시 알림 불필요
const requestAndSaveFcmToken = async (uid) => {
  // Admin 웹 앱에서는 FCM 토큰이 필요 없음
  return null;
};

// ========================
// FCM Token Auto Refresh Listener (Polling-based)
// ========================
const setupFcmTokenRefresh = (uid) => {
  // Admin 웹 앱에서는 FCM 토큰이 필요 없음
  return () => {}; // 빈 cleanup 함수 반환
};

// ========================
// FCM Token Deletion
// ========================
const removeFcmToken = async (uid) => {
  // Admin 웹 앱에서는 FCM 토큰이 필요 없음
  return;
};

// ========================
// 🔥 CRITICAL FIX: 모든 초기화 완료 후 마지막에 한 번에 export
// 이렇게 하면 TDZ 오류가 완전히 해결됩니다
// ========================
export { 
  app,
  auth,
  db,
  storage,
  functions,
  appId,
  setAdminSession,
  clearAdminSession,
  isAdminSession,
  requestAndSaveFcmToken,
  setupFcmTokenRefresh,
  removeFcmToken,
  serverTimestamp
};